import { isAfter } from "date-fns"
import { navigate } from "gatsby"
import { useCallback, useEffect, useState } from "react"

import {
  marketingClient,
  useMutation,
  useQueryClient,
  userClient,
} from "@trueskin-web/apis"
import { Dialog } from "@trueskin-web/components"
import { useAuth } from "@trueskin-web/context"
import { getErrorMessage } from "@trueskin-web/functions"
import { termsAndConditionsService } from "@trueskin-web/services"
import { useTranslation } from "@trueskin-web/translations"

const termsAndConditionsDate =
  process.env.GATSBY_TERMS_AND_CONDITIONS_UNIX_TIMESTAMP * 1000

const TermsAndConditions = () => {
  const { t } = useTranslation()

  const queryClient = useQueryClient()

  const { user: { agreedToTermsAndConditionsAt } = {} } = useAuth()

  const [isDismissed, setIsDismissed] = useState(
    termsAndConditionsService.isTermsAndConditionsDismissed()
  )

  const isTermsAndConditionSubmitted = isAfter(
    new Date(agreedToTermsAndConditionsAt),
    new Date(termsAndConditionsDate)
  )

  const {
    mutateAsync: submitTermsAgreement,
    isLoading,
    error,
  } = useMutation(userClient.submitTermsAgreement, {
    onSuccess: async () => {
      await queryClient.refetchQueries("currentUser")
      setIsDismissed(true)
    },
  })

  const dismissTermsAgreement = useCallback(async () => {
    setIsDismissed(true)

    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM
        .NEW_TERMS_AND_CONDITIONS_CLICK_ON_DISMISS,
    })

    navigate("/")

    return null
  }, [])

  useEffect(() => {
    if (
      !termsAndConditionsDate ||
      isTermsAndConditionSubmitted ||
      isDismissed
    ) {
      return
    }

    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.NEW_TERMS_AND_CONDITIONS_VIEWED,
    })
  }, [isDismissed, isTermsAndConditionSubmitted])

  if (!termsAndConditionsDate || isTermsAndConditionSubmitted || isDismissed) {
    return null
  }

  return (
    <Dialog
      initOnApiCooldown
      title={t("Start.TermsAndConditions.title")}
      primaryAction={submitTermsAgreement}
      primaryActionLabel={t("Start.TermsAndConditions.primaryAction")}
      isPrimaryActionLoading={isLoading}
      secondaryAction={dismissTermsAgreement}
      secondaryActionLabel={t("Start.TermsAndConditions.secondaryAction")}
      isSecondaryActionDisabled={isLoading}
      actionError={error ? getErrorMessage(error) : null}
    >
      {t("Start.TermsAndConditions.content")}
    </Dialog>
  )
}

export default TermsAndConditions
